import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  DiJavascript1,
  DiReact,
  DiPython,
  DiGit,
  DiJava,
  DiPostgresql,
  DiHtml5,
} from "react-icons/di";


function Techstack() {
  const techs = [
    { icon: <DiJavascript1 />, name: "JavaScript" },
    { icon: <DiPostgresql />, name: "PostgreSQL" },
    { icon: <DiReact />, name: "React.js" },
    { icon: <DiGit />, name: "Git / Version Control" },
    { icon: <DiHtml5 />, name: "HTML5" },
    { icon: <DiPython />, name: "Python" },
    { icon: <DiJava />, name: "Java" },
  ];

  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {techs.map((t, i) => (
        <Col key={i} xs={4} md={2} className="tech-icons tooltip">
          {t.icon}
          <span className="tooltip-text">{t.name}</span>
        </Col>
      ))}
    </Row>
  );
}

export default Techstack;
